import { getCookieValue } from '../_utils';

//getPromise() returns a promise that resolves to an object with a logged in flag and all FSSecurityMX cookie data
export const loggedInUser = () => {
	return new Promise(resolve => {
		let user = {
			loggedIn: false,
		};
		let userCookie = getCookieValue('FSSecurityMX');
		let parsedUser;
		if (userCookie) {
			parsedUser = JSON.parse(atob(userCookie));
			user.loggedIn = parsedUser.valid;
			if (user.loggedIn) {
				user.data = Object.assign({}, parsedUser);
			}
		} else if (sessionStorage) {
			let userSession = sessionStorage.getItem('User');
			if (userSession) {
				parsedUser = JSON.parse(userSession);
				user.loggedIn = parsedUser.loggedIn;
			}
		}
		resolve(user);
	});
};
